import React from "react";
import PropTypes from "prop-types";
export default function Select(props) {
  let { label, defValue, options, id, ...args } = props;
  return (
    <div
      className={`km__c--select-container ${
        label ? "km__c--select-container-has-label" : ""
      }`}
    >
      {label ? <label>{label}</label> : null}
      <select className="km__c--select" id={id} {...args}>
        {defValue ? <option hidden>{defValue}</option> : ""}
        {options?.map((item) => {
          let { name, value, ...optionArgs } = item;
          return (
            <option key={value} value={value} {...optionArgs}>
              {name}
            </option>
          );
        })}
      </select>
    </div>
  );
}
Select.propTypes = {
  label: PropTypes.string,
  options: PropTypes.array.isRequired,
};
